import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './Layout';
import Inicio from './Inicio';
import Eventos from './Eventos';
import Contacto from './Contacto';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Página de inicio con las imágenes */}
          <Route index element={<Inicio />} />
          {/* Sección de eventos */}
          <Route path="Eventos" element={<Eventos />} />
          {/* Sección de contacto */}
          <Route path="Contacto" element={<Contacto />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;

